/* =====================================================
   CWC_review_tabs.js
   
   Tab switching functionality for customer reviews
   ===================================================== */

(function () {
  "use strict";

  function initReviewTabs() {
    const sections = document.querySelectorAll(".cwc-review-tabs");

    if (!sections.length) return;

    sections.forEach(function (section) {
      initSection(section);
    });
  }

  function initSection(section) {
    const sectionId = section.dataset.sectionId;
    const buttons = section.querySelectorAll(".cwc-review-tabs__button");
    const grids = section.querySelectorAll(".cwc-review-tabs__grid");

    // Validation
    if (!buttons.length || !grids.length) {
      console.warn(
        "CWC Review Tabs: No tabs or content grids found in section:",
        sectionId,
      );
      return;
    }

    // Attach click handlers to each button
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        const tabId = this.getAttribute("data-tab");

        // Remove active class from all buttons
        buttons.forEach(function (btn) {
          btn.classList.remove("active");
        });

        // Remove active class from all grids
        grids.forEach(function (grid) {
          grid.classList.remove("active");
        });

        // Add active class to clicked button
        this.classList.add("active");

        // Add active class to corresponding grid
        const activeGrid = section.querySelector(
          '.cwc-review-tabs__grid[data-content="' + tabId + '"]',
        );

        if (activeGrid) {
          activeGrid.classList.add("active");
        }
      });
    });

    // Expose for debugging
    if (typeof window.CWCReviewTabs === "undefined") {
      window.CWCReviewTabs = {};
    }

    window.CWCReviewTabs[sectionId] = {
      section: section,
      buttons: buttons,
      grids: grids,
    };
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReviewTabs);
  } else {
    initReviewTabs();
  }

  // Re-initialize on Shopify section events (for theme editor)
  document.addEventListener("shopify:section:load", function (event) {
    const section = event.target.querySelector(".cwc-review-tabs");
    if (section) {
      initSection(section);
    }
  });
})();
